import _chunk from "lodash/chunk"
import { Educator, db } from "../../mp-database"

type WithCreator = {
  creator?: Educator
  createdBy?: string | Educator
}

const getCreatorId = (record: WithCreator): string =>
  typeof record.createdBy === "string"
    ? record.createdBy
    : record.createdBy?.id ?? ""

export const fetchCreators = async <T extends WithCreator>(
  records: T[]
): Promise<T[]> => {
  // disabling as this should now come from graphQL. We can't allow unfettered access to look up ids outside
  // the org of the user
  return records
}
